/* eslint-disable no-undef */

const createDownloadLink = (data, filename, mimeType) => {
  const blob = new Blob([data], { type: mimeType || 'text/csv;charset=utf-8' });
  const url = window.URL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = url;
  tempLink.setAttribute('download', filename);
  tempLink.setAttribute('target', '_blank');

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
};

const downloadLink = (link, filename) => {
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = link;
  tempLink.setAttribute('download', filename);
  tempLink.setAttribute('target', '_blank');

  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
};

// A presigned analytics export (publish-api's download exports). Same-window
// navigation, not a new tab: the file is ready long after the click, when the browser
// no longer counts it as the user's action and blocks a new tab as a popup. The URL
// carries Content-Disposition: attachment, so the browser saves it and the page
// stays where it is.
const downloadPresignedFile = (link) => {
  window.location.assign(link);
};

export default createDownloadLink;
export { downloadLink, downloadPresignedFile };
